/* eslint-disable key-spacing */
<template>
<div class="main-box">
  <div class="bg-box">
    <img class="logo-img" src="../assets/img/logo.png" alt="">
    <img class="main-img" :src="selectItem.cover" alt="" @click="goUrl">
    <img class="disk-img" src="../assets/img/disk2.png" alt="" @click="goUrl">
    <img class="join-btn" src="../assets/img/join.png" alt="" @click="showFormData">
    <div class="enter-box">
      <img class="pointer-btn" src="../assets/img2/poniter.png" alt="" @click="goUrl">
      <img class="enter-btn" src="../assets/img2/goin.png" alt="" @click="goUrl">
    </div>
  </div>
  <div class="card-wrap">
    <ul class="swiper-wrapper"  v-if="list.length">
      <li class="swiper-slide" v-for="(item, index) in list" :key="index">
        <img :src="item.thumbnail" alt="">
      </li>
    </ul>
  </div>
  <div class="form-box" v-if="showForm && false">
    <div class="close-btn" @click="closeForm"></div>
    <div class="form" v-show="!showSuccess">
      <div class="box-title">申请入驻</div>
      <div class="name-btn input-btn">
        <div class="left-icon"></div>
        <div class="right-box">
          <input v-model="formData.userName" type="text" placeholder="姓名">
        </div>
      </div>
      <div class="phone-btn input-btn">
        <div class="left-icon"></div>
        <div class="right-box">
          <input v-model="formData.phone" type="text" placeholder="手机号" oninput="value=value.replace(/[^\d]/g,'')">
        </div>
      </div>
      <div class="company-btn input-btn">
        <div class="left-icon"></div>
        <div class="right-box">
          <input  v-model="formData.companyName" type="text" placeholder="机构/单位名称">
        </div>
      </div>
      <div class="submit-btn" @click="submit">
        <div class="submit">
          <div>提交</div>
          <div class="icon-box">
            <img v-show="!checkPhone" src="../assets/img/go2.png" alt="">
            <img v-show="checkPhone" src="../assets/img/go1.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="submit-success"  v-show="showSuccess">
      <div class="success-img">
        <img src="../assets/img/right.png" alt="">
      </div>
      <div class="text">
        提交成功
      </div>
      <div class="time">
        {{time}}
      </div>
    </div>
  </div>
  <div class="form-box2" v-if="showForm">
    <vue-scroll>
    <div class="form-inner">
      <div class="form-page-box " v-show="!showSuccess">
        <div class="close-btn" v-show="!showPhoneList" @click="closeForm"></div>
        <!-- <div class="call-btn" @click="callPhone"></div> -->
        <div class="form-page">
          <!-- <vue-scroll> -->
          <div class="form" v-show="!showSuccess">
            <div class="box-title">新华云展</div>
            <div class="box-text">新华云展是新华社客户端主办的数字文博展示轻应用，运用先进的数字化、可视化、AI技术构建了优秀文化的传播展示平台。平台汇聚优质的数字展览内容，为博物馆、文化机构打造永不落幕的“云展览”，同时也让海内外观众足不出户即可身临其境畅游数字文化“新视界”。诚挚欢迎广大博物馆、纪念馆等文化机构入驻新华云展。</div>
            <div class="company-btn input-btn">
              <div class="left-icon"></div>
              <div class="right-box">
                <input  v-model="formData.companyName" type="text" placeholder="机构/单位名称*">
              </div>
            </div>
            <div class="name-btn input-btn">
              <div class="left-icon"></div>
              <div class="right-box">
                <input v-model="formData.userName" type="text" placeholder="姓名*">
              </div>
            </div>
            <div class="phone-btn input-btn">
              <div class="left-icon"></div>
              <div class="right-box">
                <input v-model="formData.phone" type="text" placeholder="手机号*" oninput="value=value.replace(/[^\d]/g,'')" @>
              </div>
            </div>
            <div class="submit-btn" :class="{'checked':checkPhone && formData.userName.replace(/^\s+|\s+$/g,'') && formData.companyName.replace(/^\s+|\s+$/g,'')}" @click="submit">
                申请入驻
            </div>
            <!-- <div class="call-btn" @click="callPhone">
                电话咨询
            </div> -->
            <div class="contact-wrap">
              <div class="contact-box">
                <div class="phone-btn" @click="showPhoneList = true">
                  <img src="../assets/img2/phone2.png" alt="">
                </div>
                <div class="line"></div>
                <div class="wechat-btn" @click="showWwchat = true">
                  <img src="../assets/img2/wechat.png" alt="">
                </div>
                <div class="line"></div>
                <div class="email-btn" @click="goEmail('mailto:jane@vizen.cn')">
                  <img src="../assets/img2/email.png" alt="">
                </div>
              </div>
            </div>
            <!-- <div class="line-1"></div> -->
          </div>
          <div class="list">
            <div class="list-item">
              <div class="list-text">
                <p>技术支持：微景天下（北京）科技有限公司</p>
              </div>
            </div>
          </div>
          <!-- </vue-scroll> -->
        </div>
        <div class="bottom-wrap">
          <div class="bottom-box">
            <div class="left-box">
              <img src="../assets/img2/logo.png" alt="">
            </div>
            <div class="right-box">
              <p>
                新华社客户端
              </p>
              <div class="down" @click="down">
                下载
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </vue-scroll>

    <div class="submit-success2"  v-if="showSuccess">
      <div class="close-btn" @click="closeForm"></div>
      <div class="success-img">
        <img src="../assets/img2/right.png" alt="">
      </div>
      <div class="text">
        提交成功
      </div>
      <div class="time">
        {{time}}
      </div>
    </div>
    <div class="phone-dia" v-show="showPhoneList">
      <div class="phone-bottom">
        <div class="phone-list">
          <div class="phone-item" @click="callPhone('tel: 13910515210')">
            13910515210
          </div>
          <div class="phone-item" @click="callPhone('tel: 15001009582')">
            15001009582
          </div>
        </div>
        <div class="cancle-btn" @click="showPhoneList = false">取消</div>
      </div>
    </div>
    <div class="wechat-dia" v-show="showWwchat" @click.stop="showWwchat = false">
      <div class="img-box">
        <img src="../assets/img2/wechatqr.png" alt="">
      </div>
    </div>
  </div>
  <xuexiqiangguo v-if="showXXQGpage" @hidePage="hidePage"></xuexiqiangguo>
  <museumWelPage v-if="showMuseumWelPage"></museumWelPage>
</div>
</template>

<script>
import xuexiqiangguo from '../components/xuexiqiangguo'
import museumWelPage from '../components/museumWelPage'

export default {
  name: 'Mobile',
  components: {
    xuexiqiangguo: xuexiqiangguo,
    museumWelPage: museumWelPage
  },
  data () {
    return {
      showWwchat: false,
      showPhoneList: false,
      showForm: false,
      showSuccess: false,
      initPage: true,
      time: '',
      selectItem: {},
      mySwiper: {
        realIndex: 0
      },
      checkPhone: false,
      formData: {
        name: '',
        phone: '',
        company: ''
      },
      list: [
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        },
        {
          cover: ''
        }
      ],
      showXXQGpage: false, // 学习强国欢迎页
      showMuseumWelPage: false, // 博物馆欢迎页
      listData: {
        'data': {
          'total': 6,
          'searchTotal': 6,
          'rows': [
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'http://szzt.artmuseum.tsinghua.edu.cn/show/2017-4-3/1491188686841.shtml?sceneid=97686',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/161467865400063451.png',
            'title': '晚霞余晖',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/16146786220008521.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
           },
          // {
          //   'id': '5eba1288d628f700011cf612',
          //   'vrUrl': 'https://webapp.vizen.cn/dizhenju/mobile.html?xinhua=1',
          //   'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/160274454800082899.png',
          //   'title': '地震局',
          //   'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/160274452600092450.png',
          //   'viewNum': 1,
          //   'subtitle': '',
          //   'status': 1
          //  },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/rongtie/mobile.html',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/160128140300026894.png',
            'title': '篆刻展',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/160128141300036401.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
           },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2008019550?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159667929800075812.png',
            'title': '地质馆',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/15966792900003944.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
           },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2008019607?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159667877600081673.png',
            'title': '医药馆',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159667876800022334.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2007161990?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159616304500048211.png',
            'title': '政法大学',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159616303400069599.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2007199859?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159532519600030053.png',
            'title': '人大',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/15953251890008860.jpg',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          // {
          //   'id': '5eba1288d628f700011cf612',
          //   'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2007107877?isAutoJump=true',
          //   'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159532510400056201.png',
          //   'title': '清华',
          //   'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159532509700018046.jpg',
          //   'viewNum': 1,
          //   'subtitle': '',
          //   'status': 1
          // },
          {
            'id': '5eba1288d628f700011cf612',
            'vrUrl': 'https://gyz.vizen.cn',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/158952990300050386.png',
            'title': '国云展',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/158952989300099264.jpg',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5eba12fdd628f700011cf6a8',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2007014999?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159428166900040047.png',
            'title': '传媒博物馆',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159428166300063463.jpg',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5eba12fdd628f700011cf6a8',
            'vrUrl': 'https://webapp.vizen.cn/pro_vizen_template/#/expo/2006349355?isAutoJump=true',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159400629000073988.png',
            'title': '琅嬛书院',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159400628600085201.jpg',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          // {
          //   'id': '5eba12fdd628f700011cf6a8',
          //   'vrUrl': 'https://webapp.vizen.cn/nixingfeixiang/index.html',
          //   'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159342465600095049.png',
          //   'title': '逆行飞翔',
          //   'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/159342465000050223.jpg',
          //   'viewNum': 1,
          //   'subtitle': '',
          //   'status': 1
          // },
          {
            'id': '5eba12fdd628f700011cf612',
            'vrUrl': 'https://webapp.vizen.cn/lunarBaseVR/index.html',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/158953037900067998.png',
            'title': '月球舱',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/158953037500096382.jpg',
            'viewNum': 1,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5eba135bd628f700011cf6a9',
            'vrUrl': 'https://webapp.vizen.cn/inspectiontrainxinhua/mobile.html',
            'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/158953024900094327.png',
            'title': '铁科院--高速综合检测列车',
            'cover': 'https://vepic-material.vizen.cn/museumcloud/pic/158953024100083589.jpg',
            'viewNum': 3,
            'subtitle': '',
            'status': 1
          },
          {
            'id': '5e846c074e52d7000141e80b',
            'vrUrl': 'https://webapp.vizen.cn/gugong_app_pc/index.html',
            'thumbnail': 'https://vepic-material.vizen.cn/wenwuyun/test/pic/158513119900044647.png',
            'title': '故宫3.0',
            'cover': 'https://vepic-material.vizen.cn/wenwuyun/test/pic/15851311920008721.png',
            'viewNum': 1,
            'subtitle': '',
            'status': 4
          },
          {
            'id': '5e846c2e4e52d7000141e80d',
            'vrUrl': 'https://webapp.vizen.cn/jingdezhen/mobile.html',
            'thumbnail': 'https://vepic-material.vizen.cn/wenwuyun/test/pic/158513108200039595.png',
            'title': '景德镇',
            'cover': 'https://vepic-material.vizen.cn/wenwuyun/online/pic/158553248100013154.png',
            'viewNum': 0,
            'subtitle': '',
            'status': 4
          }
          // {
          //   'id': '5eba1288d628f700011cf6a7',
          //   'vrUrl': 'https://webapp.vizen.cn/dainiquwuhan/index.html',
          //   'thumbnail': 'https://vepic-material.vizen.cn/museumcloud/pic/159013436400080069.png',
          //   'title': '云游武汉',
          //   'cover': 'http://vepic-material-test.vizen.cn/museumcloud/pic/158988248500085463.jpg',
          //   'viewNum': 1,
          //   'subtitle': '',
          //   'status': 1
          // }
          ]
        }
      }
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    this.util.addStatistics('500714852', '500714853')
    if (this.$route.path === '/xuexiqiangguo') {
      this.showXXQGpage = true
      setTimeout(() => {
        if (window.MtaH5) {
          window.MtaH5.clickStat('page-xuexiqiangguo')
        }
      }, 30)
    }
    if (this.$route.path === '/museumWelPage') {
      document.title = '云游博物馆'
      this.showMuseumWelPage = true
      setTimeout(() => {
        if (window.MtaH5) {
          window.MtaH5.clickStat('page-museumWelPage')
        }
        window.hideVizenLoading()
      }, 30)
      return false
    }
    document.title = '新华云展'
    let shareUrl = location.href
    let shareTitle = '新华云展'
    let shareDesc = '足不出户，畅游云展'
    let shareImg = location.protocol + '//cimg.vizen.cn/release/pic/21259d87a59c423c1b843002286aaa4d.png/imgsmall'
    window.getShareInfoSub(shareUrl, shareTitle, shareDesc, shareImg)
    this.getList()
  },
  watch: {
    'formData.phone': {
      handler: function (newVal) {
        var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(newVal)) {
          this.checkPhone = false
        } else {
          this.checkPhone = true
        }
      },
      immediate: true
    },
    'mySwiper.realIndex': {
      handler: function (newVal) {
        this.selectItem = this.list[newVal]
      }
    }
  },
  methods: {
    goUrl () {
      // self.util.addMtah5ClickStat(self.$store.state.appId, 'pano-' + self.appInfo.cover, self.$api)
      window.MtaH5.clickStat('vr-' + this.selectItem.id)
      setTimeout(() => {
        location.href = this.selectItem.vrUrl
      }, 300)
    },
    callPhone (phone) {
      window.location.href = phone
    },
    goEmail (email) {
      window.location.href = email
    },
    initSwiper () {
      // let self = this
      this.mySwiper = new window.Swiper('.card-wrap', {
        autoplay: false,
        slideToClickedSlide: false,
        direction: 'horizontal',
        initialSlide: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true,
        centeredSlides: true,
        effect: 'coverflow',
        slidesPerView: 3.75,
        coverflowEffect: {
          rotate: 0,
          stretch: -25,
          depth: 500,
          modifier: 1,
          slideShadows: false
        },
        // // spaceBetween: 16 / 375 * window.screen.width,
        // // slidesOffsetAfter: 14 / 375 * window.screen.width,
        // // slidesOffsetBefore: -28 / 375 * window.screen.width,
        on: {
          transitionEnd: function () {
            this.loopFix()
          },
          tap: function (swiper, event) {
            this.slideTo(this.clickedIndex, 100, true)
          },
          loopFix: function () {
            // console.log('fix')
          }
        }
      })
      if (!this.showXXQGpage) {
        this.mySwiper.autoplay.start()
      }
    },
    getList () {
      this.list = this.listData.data.rows.slice(0, 10)
      this.selectItem = this.list[0]
      setTimeout(() => {
        this.initSwiper()
      }, 100)
      setTimeout(() => {
        window.hideVizenLoading()
      }, 300)
    },
    down () {
      location.href = 'https://d.zhongguowangshi.com'
    },
    // 判断是否微信
    isWeiXin () {
      if (/MicroMessenger/gi.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    // 判断是安卓还是iOS
    isAndroid_ios () {
      let u = navigator.userAgent
      // let app = navigator.appVersion
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      return isAndroid === true
    },
    openApp (src) {
      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      let ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      window.setTimeout(function () {
        document.body.removeChild(ifr)
      }, 2000)
    },
    closeForm () {
      this.showForm = false
      this.showSuccess = false
      this.formData.userName = ''
      this.formData.phone = ''
      this.formData.companyName = ''
    },
    showFormData () {
      this.showForm = true
    },
    submit () {
      if (this.checkPhone && this.formData.userName.replace(/^\s+|\s+$/g, '') && this.formData.companyName.replace(/^\s+|\s+$/g, '')) {
        this.formData.userName = this.formData.userName.replace(/^\s+|\s+$/g, '')
        this.formData.companyName = this.formData.companyName.replace(/^\s+|\s+$/g, '')
        this.$api.enter(this.formData).then(res => {
          if (res.code === '0') {
            this.time = this.util.formatDate(new Date(), 'yyyy.MM.dd  hh.mm')
            this.showSuccess = true
          }
        })
      }
    },
    hidePage () {
      this.showXXQGpage = false
      this.mySwiper.autoplay.start()
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/25)*1rem;
  }
  @keyframes myanimation {
    0%   {transform: scale(1);}
    25%  {transform: scale(1.1);}
    50%  {transform: scale(1);}
    100% {transform: scale(0.9);}
  }
  $animationTime: 0.6s;
  .main-box {
    // width: 100vw;
    // height: 100vh;
    /*position: relative;*/
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    .bg-box {
      position: relative;
      // width: 100vw;
      // height: 100vh;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      .main-img {
        width: 100%;
        height: auto;
      }
      .disk-img {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100vw;
        height: auto;
      }
      .join-btn {
        width: rem(38);
        height: rem(78);
        position: absolute;
        right: rem(20);
        top: rem(20)
      }
      .logo-img {
        width: rem(90);
        height: rem(30);
        position: absolute;
        left: rem(20);
        top: rem(20)
      }
      .enter-box {
        // width: rem(72);
        height: rem(24);
        position: absolute;
        right: rem(14);
        top: rem(317);
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        .enter-btn {
          width: rem(72);
          margin-left: rem(6);
        }
        .pointer-btn {
          width: rem(18);
          height: rem(18);
          animation: myanimation 2s linear infinite;
        }
      }
    }
    .card-wrap {
      width: rem(375);
      height: rem(100);
      position: absolute;
      left: rem(0);
      bottom: rem(20);
      .swiper-wrapper {
        width: rem(375);
        display: flex;
        align-items: center;
        // justify-content: center;
      }
      .swiper-slide {
        width: rem(100);
        height: rem(100);
        border-radius: rem(15);
        overflow: hidden;
      }
      // .swiper-slide-prev,.swiper-slide-next {
      //   border-radius: rem(20);
      //   // transform: scale(1.4);
      //   width: rem(70);
      //   height: rem(70);
      // }
      // .swiper-slide-active{
      //   border-radius: rem(25);
      //   // transform: scale(2);
      //   width: rem(100);
      //   height: rem(100);
      //   border: 1px solid #FFFFFF;
      //   // box-sizing: border-box;
      //   box-shadow: 0 rem(5) rem(8) 0 rgba(0,0,0,0.50);
      //   // margin: 0 rem(30);
      // }
      // .swiper-slide-prev {
      //   margin: 0 rem(20)
      // }
      // .swiper-slide-next {
      //   margin-right: rem(20)
      // }
      img {
        width: 100%;
        height: 100%;
        // width: rem(100);
        // height: rem(100);
        // border-radius: rem(25);
      }
    }
    .form-box {
      position: absolute;
      // width: 100vw;
      // height: 100vh;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: url('../assets/img/bg.png');
      background-size: cover;
      text-align: center;
      z-index: 99;
      .close-btn {
        width: rem(40);
        height: rem(40);
        position: absolute;
        top: rem(20);
        right: rem(20);
        // background: url('../assets/img/close.png');
        background-size: cover;
      }
      .box-title {
        margin-top: rem(64);
        font-family: PingFangSC-Light;
        font-size: rem(24);
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: rem(30);
        margin-bottom: rem(50);
      }
      .input-btn {
        border:1px solid rgba(0, 0, 0, 0.2);
        border-radius: 3px;
        width: rem(315);
        height: rem(40);
        margin: rem(15) auto 0;
        display: flex;
        align-items: center;
        &.name-btn .left-icon {
          width: rem(60);
          height: rem(40);
          background: url('../assets/img/name.png');
          background-size: cover;
        }
        &.phone-btn .left-icon {
          width: rem(60);
          height: rem(40);
          background: url('../assets/img/phone.png');
          background-size: cover;
        }
        &.company-btn .left-icon {
          width: rem(60);
          height: rem(40);
          background: url('../assets/img/company.png');
          background-size: cover;
        }
        .right-box {
          margin-left: rem(20);
          width: rem(215);
        }
        input {
          border: 0px;
          outline-style: none ;
          padding: rem(10) rem(0);
          width: 100%;
          height: rem(40);
          background: rgba(0, 0, 0, 0);
          font-size: rem(16);
          letter-spacing: rem(4);
          color: #FF7730;
        }
        ::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(255, 255, 255, 0.6);
        }
      }
      .submit-btn {
        width: rem(315);
        height: rem(60);
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;
        border-radius: 3px;
        margin: rem(15) auto;
        .submit {
          font-family: PingFangSC-Regular;
          font-size: rem(20);
          color: #FFFFFF;
          letter-spacing: rem(5.56);
          text-align: right;
          display: flex;
          align-items: center;
          width: rem(85);
          margin: auto;
          height: rem(60);
          .icon-box {
            width: rem(26);
            height: rem(26);
            margin-left: rem(6);
            margin-top: rem(4);
          }
          img {
            width: rem(26);
          }
        }
      }
      .submit-success {
        .success-img {
          width: rem(150);
          margin: rem(145) auto rem(40);
          img {
            width: rem(150);
          }
        }
        .text {
          font-family: PingFangSC-Light;
          font-size: rem(24);
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: rem(24);
        }
        .time {
          font-family: PingFangSC-Light;
          font-size: rem(14);
          color: #FFFFFF;
          letter-spacing: 0;
          margin-top: rem(15);
          line-height: rem(14);
        }
      }
    }
    .form-box2 {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: #fff;
      z-index: 99;
      .form-inner {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: auto;
        .form-page-box {
          background-image: url('../assets/img2/top.png');
          background-position: top left;
          background-size: 100% auto;
          background-repeat: no-repeat;
          text-align: center;
          .close-btn {
            width: rem(30);
            height: rem(30);
            position: absolute;
            top: rem(20);
            right: rem(20);
            background: url('../assets/img2/close.png');
            background-size: cover;
          }
          //.call-btn {
          //  width: rem(50);
          //  height: rem(50);
          //  position: fixed;
          //  bottom: rem(43);
          //  right: rem(20);
          //  background: url('../assets/img2/phone.png');
          //  background-size: cover;
          //  z-index: 999;
          //}
          .form-page {
            width: rem(315);
            margin: rem(0) auto rem(0);
            padding-top: rem(30);
            .box-title {
              font-family: PingFangSC-Light;
              font-size: rem(24);
              color: #FFFFFF;
              letter-spacing: rem(8);
              line-height: rem(30);
              margin-bottom: rem(40);
            }
            .box-text {
              font-family: PingFangSC-Light;
              font-size: rem(12);
              color: #4A4A4A;
              letter-spacing: rem(0);
              line-height: rem(30);
              margin-bottom: 20px;
              padding-top: 20px;
              text-align: justify;
            }
            .input-btn {
              margin-bottom: rem(15);
              .left-icon {
                display: none;
              }
              .right-box {
                // width: rem(275);
                // margin-left: ;
                input {
                  text-align: center;
                  border: 1px solid rgba(13, 42, 146, 0.2);
                  border-radius: 3px;
                  outline-style: none ;
                  padding: rem(15) rem(20);
                  width: rem(275);
                  height: rem(15);
                  background: rgba(0, 0, 0, 0);
                  font-size: rem(16);
                  letter-spacing: rem(4);
                  color: #0D2A92;
                }
                ::-webkit-input-placeholder {
                  /* WebKit browsers */
                  color: #0D2A92;;
                }
              }
            }
            //.submit-btn {
            //  background: rgba(24, 71, 159, 0.2);
            //  border-radius: 22.5px;
            //  font-size: rem(15);
            //  letter-spacing: rem(2.8);
            //  width: rem(140);
            //  height: rem(33);
            //  margin: auto;
            //  margin-top: rem(24);
            //  line-height: rem(33);
            //  color: #FFFFFF;
            //}
            .submit-btn {
              text-align: center;
              border: 1px solid rgba(24, 71, 159, 0.2);
              border-radius: 3px;
              outline-style: none ;
              padding: rem(15) rem(20);
              width: rem(275);
              height: rem(15);
              line-height: rem(15);
              // background: rgba(0, 0, 0, 0);
              background: rgba(24, 71, 159, 0.2);
              font-size: rem(16);
              letter-spacing: rem(4);
              color: #FFF;
            }
            .submit-btn.checked {
              background: #18479F;
              border: 1px solid rgba(13, 42, 146, 0.2);
            }
            .call-btn {
             // background: rgba(24, 71, 159, 0.2);
              border-radius: 22.5px;
              font-size: rem(15);
              letter-spacing: rem(2.8);
              width: rem(140);
              height: rem(33);
              margin: auto;
              margin-top: rem(24);
              line-height: rem(33);
              color: #18479F;
              border-style:solid;
              border-width:1px;
              border-color:#18479F;
            }
            .contact-wrap {
              margin-top: rem(30);
              height: rem(40);
              .contact-box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: rem(40);
                padding: 0 rem(20);
                img {
                  // width: rem(60);
                  height: rem(20);
                }
                .line {
                  width: 1px;
                  background: #18479F;
                  height: rem(20);
                }
              }
            }
            .line-1 {
              width: 100%;
              height: rem(0.5);
              margin-top: rem(30);
              background: rgba(13, 42, 146, 0.596);;
            }
            .list {
              margin-top: rem(20);
              // margin-bottom: rem(20);
            .list-item {
              // margin-bottom: rem(40);
              .list-title {
                  font-family: PingFangSC-Medium;
                  font-size: rem(14);
                  color: #18479F;
                  letter-spacing: 0;
                  text-align: center;
                  line-height: rem(14);
                  position: relative;
                  font-weight: bold;
                  // background: red;
                  &::after{
                    content: ' ';
                    width: rem(12);
                    height: 0;
                    border-bottom: 1px solid #18479F;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: rem(-5.5);
                  }
              }
              .list-text {
                // margin-top: rem(18);
                // background: #000000;
                p {
                  margin: 0;
                  padding: 0;
                  font-size: rem(12);
                  // margin-bottom: rem(40);
                  // background: #228a30;
                }
              }
            }
          }
        }
        .bottom-wrap {
          margin-top: rem(20);
          height: rem(140);
          background: url('../assets/img2/bottom.png') no-repeat;
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;
          .bottom-box {
            width: rem(221);
            // padding: 0 rem(77);
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left-box {
              width: rem(80);
              height: rem(80);
              img {
                width: rem(80);
                height: rem(80);
              }
            }
            .right-box{
              width: rem(100);
              height: rem(70);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-between;
              justify-content: center;
              p {
                font-family: PingFangSC-Medium;
                font-size: rem(16);
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
              }
              .down {
                width: rem(90);
                height: rem(30);
                background: #FFFFFF;
                border-radius: rem(20);
                font-family: PingFangSC-Medium;
                font-size: rem(15);
                color: #02378A;
                letter-spacing: rem(2);
                text-align: center;
                line-height: rem(30);
              }
            }
          }
        }
      }
    }
    .submit-success2 {
      /*width: 100vw;*/
      /*height: 100vh;*/
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      text-align: center;
      .close-btn {
          width: rem(40);
          height: rem(40);
          position: absolute;
          top: rem(20);
          right: rem(20);
          background: url('../assets/img/close.png');
          background-size: cover;
        }
      .success-img {
        width: rem(150);
        margin: rem(110) auto rem(40);
        img {
          width: rem(150);
        }
      }
      .text {
        font-family: PingFangSC-Light;
        font-size: rem(24);
        color: #010101;
        letter-spacing: 0;
        line-height: rem(24);
      }
      .time {
        font-family: PingFangSC-Light;
        font-size: rem(14);
        color: #010101;
        letter-spacing: 0;
        margin-top: rem(15);
        line-height: rem(14);
      }
    }
    .phone-dia {
      /*width: 100vw;*/
      /*height: 100vh;*/
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
      .phone-bottom {
        /*width: 100vw;*/
        // height: 100vh;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        .phone-list {
          margin: 0 rem(5);
          background: #fff;
          border-radius: rem(20);
          .phone-item {
            height: rem(50);
            margin: 0 rem(30);
            line-height: rem(50);
            letter-spacing: rem(3);
            color: #18479F;
            &:first-child {
              border-bottom:  1px solid #18479F;
            }
          }
        }
        .cancle-btn{
          height: rem(50);
          margin: rem(10) rem(5) rem(5);
          line-height: rem(50);
          letter-spacing: rem(3);
          color: #18479F;
          background: #fff;
          border-radius: rem(15);
        }
      }
    }
    .wechat-dia{
      /*width: 100vw;*/
      /*height: 100vh;*/
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
      .img-box {
        width: rem(180);
        height: rem(180);
        position: absolute;
        left: 50%;
        bottom: rem(240);
        transform: translateX(-50%);
        background: #fff;
        border-radius: rem(10);
        img {
          width: rem(150);
          height: rem(150);
          margin: rem(15);
        }
      }
    }
  }
  }

</style>
